import useDisplayModal from '../hooks/useDisplayModal';
import TCPopup from './modals/T&CPopup';

const PayOutChartPerLeadProgram = () => {
    const { open: showTCPopup, handleOpen: openTCPopup, handleClose: closeTCPopup } = useDisplayModal();
    return (
        <>
                <div className="popup-content payout-chart free-join">
                    <h3>Payout Chart - Pay Per Lead (Free join)</h3>

                    <div className="content">
                        <div className="table">
                            <table className="auto-name">
                                <thead>
                                    <tr>
                                        <th colspan="2">Traffic</th>
                                        <th>Commission</th>
                                    </tr>

                                    <tr className="rows">
                                        <th>Leads (Joins)</th>
                                        <th>Upgrades</th>
                                        <th>Per Join</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>2 per day</td>
                                        <td>$2.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>3 per day</td>
                                        <td>$3.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>4 per day</td>
                                        <td>$4.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>5 per day</td>
                                        <td>$5.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>6 per day</td>
                                        <td>$6.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>7 per day</td>
                                        <td>$7.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>8 per day</td>
                                        <td>$8.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>9 per day</td>
                                        <td>$9.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>10 per day</td>
                                        <td>$10.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>11 per day</td>
                                        <td>$11.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>12 per day</td>
                                        <td>$12.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>13 per day</td>
                                        <td>$13.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>14 per day</td>
                                        <td>$14.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>15 per day</td>
                                        <td>$15.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>16 per day</td>
                                        <td>$16.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>17 per day</td>
                                        <td>$17.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>18 per day</td>
                                        <td>$18.00</td>
                                    </tr>

                                    <tr className="rows">
                                        <td>Average 100 per day</td>
                                        <td>19 per day</td>
                                        <td>$19.00</td>
                                    </tr>

                                    <tr className="rows alt">
                                        <td>Average 100 per day</td>
                                        <td>20 per day</td>
                                        <td>$20.00</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <h5>Pay Per Lead (Free join) - Minimum Requirements</h5>
                        <ul className="Example">
                            <li>
                                For full details refer to <a href="" onClick={e=>{e.preventDefault();openTCPopup()}}>Affiliate Agreement.</a>
                            </li>
                        </ul>
                    </div>
                </div>
            <TCPopup open={showTCPopup} close={closeTCPopup} />
        </>

    )
}

export default PayOutChartPerLeadProgram;